import { render, staticRenderFns } from "./DataSidebar.vue?vue&type=template&id=ea5c5776&"
import script from "./DataSidebar.vue?vue&type=script&lang=js&"
export * from "./DataSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DataSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports